import Paper from '@mui/material/Paper';

import Product from '../Product';
import Sidebar from '../Sidebar';
import './_maincontainer.scss';

const MainContainer = () => {
  return (
    <section className='main-container'>
      <div className='container-fluid'>
        <Paper style={{ padding: '12px' }}>
          <div className='row'>
            <div className='col-lg-2 col-md-3 col-sm-4'>
              <Sidebar />
            </div>
            <div className='col-lg-10 col-md-9 col-sm-8'>
              <Product />
            </div>
          </div>
        </Paper>
      </div>
    </section>
  );
};

export default MainContainer;
